import React, { useRef } from 'react';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import { useTranslation } from 'react-i18next';

import CommonTooltip from '../common-tooltip/CommonTooltip';
import FilePicker from './FilePicker';

import scss from './FileAttachButton.module.scss';

function FileAttachButton({ onPick, accept, multiple = true, disabled = false, ariaLabel = 'Attach files', children }) {
  const { t } = useTranslation();

  const pickerRef = useRef(null);

  const handleClick = () => {
    pickerRef.current?.open?.();
  };

  return (
    <>
      <CommonTooltip title={t('attachFiles')}>
        <span>
          <button
            type='button'
            className={scss.button}
            onClick={handleClick}
            disabled={disabled}
            aria-label={ariaLabel}
            aria-disabled={disabled}>
            {children ?? <AttachFileOutlinedIcon />}
          </button>
        </span>
      </CommonTooltip>

      <FilePicker ref={pickerRef} multiple={multiple} accept={accept} disabled={disabled} onPick={onPick} />
    </>
  );
}

export default FileAttachButton;
